import { useTranslation } from 'react-i18next'
import { ROOM_KINDS } from 'service/DormService'

import styles from './RoomsTab.module.scss'

const RoomsTab = ({
  buildings,
  rooms,
  filterBuilding,
  setFilterBuilding,
  setEditingRoom,
  setAssigning,
}) => {
  const { t } = useTranslation('common')

  return (
    <>
      <div className={styles.toolbar}>
        <select
          className="unv-input"
          value={filterBuilding}
          onChange={(e) => setFilterBuilding(e.target.value)}
        >
          <option value="">{t('dorm.all_buildings')}</option>
          {buildings.map((b) => (
            <option key={b.id} value={b.id}>{b.name}</option>
          ))}
        </select>
        <button
          className="unv-btn unv-btn--primary"
          onClick={() =>
            setEditingRoom({
              kind: 'double',
              capacity: 2,
              gender: 'MIXED',
              monthly_rate: 0,
              is_active: true,
            })
          }
        >
          {t('dorm.add_room')}
        </button>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>{t('dorm.col_building')}</th>
            <th>{t('dorm.col_number_short')}</th>
            <th>{t('dorm.col_floor_short')}</th>
            <th>{t('dorm.col_kind')}</th>
            <th>{t('dorm.col_seats')}</th>
            <th>{t('dorm.col_taken')}</th>
            <th>{t('dorm.col_price')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {rooms.map((r) => (
            <tr key={r.id}>
              <td>{r.building_name}</td>
              <td>{r.number}</td>
              <td>{r.floor}</td>
              <td>{ROOM_KINDS[r.kind]}</td>
              <td>{r.capacity}</td>
              <td className={r.is_full ? styles.full : styles.free}>
                {r.occupied} / {r.capacity}
              </td>
              <td>{r.monthly_rate}</td>
              <td>
                <button className={styles.smallBtn} onClick={() => setEditingRoom(r)}>
                  {t('dorm.edit_short')}
                </button>
                <button
                  className={styles.smallBtn}
                  disabled={r.is_full}
                  onClick={() => setAssigning({ room: r.id, monthly_payment: r.monthly_rate })}
                >
                  {t('dorm.settle_btn')}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default RoomsTab
